import React from 'react';

export default ({ series, ...props })=>{
    if (!Array.isArray(series) || series.length < 2) {
        return null;
    }
    return props.children;
};
